<script>
import { crudMethods } from '@state/helpers'
import moment from 'moment'
import { debounce } from 'lodash'
import dokumenJson from './dokumen.json'
import ProjectTable from '@/src/router/views/pages/transaksi/proyek/project-table.vue'
import ProjectSummary from '@/src/router/views/pages/transaksi/proyek/project-summary.vue'

export default {
  components: {
    ProjectTable,
    ProjectSummary,
  },
  props: {
    user: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    url: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      required: true,
    },
    crumbs: {
      type: Array,
      default: () => {
        return []
      },
    },
    fields: {
      type: Array,
      default: () => {
        return []
      },
    },
    model: {
      type: Object,
      default: () => {
        return {}
      },
    },
    schema: {
      type: Object,
      default: () => {
        return {}
      },
    },
    options: {
      type: Object,
      default: () => {
        return {}
      },
    },
    tipe: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      baseURL: process.env.VUE_APP_API_ENDPOINT,
      routes: '/transaksi/proyek',
      pkId: null,
      rows: 1,
      qCari: '',
      perPage: 25,
      optionPerPage: [
        { value: 15, text: 15 },
        { value: 25, text: 25 },
        { value: 50, text: 50 },
        { value: 100, text: 100 },
      ],
      currentPage: 1,
      total: 1,
      from: 1,
      to: 1,
      items: [],
      showDokumens: [],
      allDokumens: [],
      dataDokumens: dokumenJson,
      dokumenProyeks: [],
      dokumens: [
        {
          tipe: 'RAB',
          name: 'RAB',
          status: null,
        },
        {
          tipe: 'PANJAR',
          name: 'Panjar',
          status: null,
        },
        {
          tipe: 'KL',
          name: 'KL',
          status: null,
        },
        {
          tipe: 'BAUT',
          name: 'BAUT',
          status: null,
        },
        {
          tipe: 'BASO',
          name: 'BASO',
          status: null,
        },
        {
          tipe: 'P8',
          name: 'P8',
          status: null,
        },
        {
          tipe: 'KFS',
          name: 'KFS',
          status: null,
        },

        {
          tipe: 'BA-SPLITTING',
          name: 'BA-SPLITTING',
          status: null,
        },
        {
          tipe: 'SPH',
          name: 'SPH',
          status: null,
        },
        {
          tipe: 'SKES',
          name: 'SKES',
          status: null,
        },
        {
          tipe: 'BAST',
          name: 'BAST',
          status: null,
        },

        {
          tipe: 'BARD',
          name: 'BARD',
          status: null,
        },
        {
          tipe: 'BAPLA',
          name: 'BAPLA',
          status: null,
        },
        {
          tipe: 'BAPL',
          name: 'BAPL',
          status: null,
        },
        {
          tipe: 'RC',
          name: 'RC',
          status: null,
        },
        {
          tipe: 'NPK',
          name: 'NPK',
          status: null,
        },
        {
          tipe: 'NOKES',
          name: 'NOKES',
          status: null,
        },
        {
          tipe: 'PO',
          name: 'PO',
          status: null,
        },
        {
          tipe: 'EVIDENCE',
          name: 'EVIDENCE',
          status: null,
        },
        {
          tipe: 'DLL',
          name: 'DLL',
          status: null,
        },
      ],
      years: [],
      year: moment().format('YYYY'),
      modalDokumen: false,
      modalAllDokumen: false,
      summary: {},
      istYpingSearch: true,
      filterJumlahs: ['SEMUA', 'BELUM UPLOAD'],
      filterJumlah: 'SEMUA',
    }
  },
  computed: {
    checkAuthorized() {
      return (
        this.user.role === 'ROOT' ||
        this.user.role === 'ADMIN' ||
        this.user.role === 'KABAG-SALES-DELIVERY' ||
        this.user.role === 'SUPPORT-SALES-DELIVERY'
      )
    },
  },
  watch: {
    items: {
      handler: function(newVal, oldval) {
        for (var i = 0; i < newVal.length; i++) {
          this.items[i]['no'] = i + this.from
        }
      },
      deep: true,
    },
    // qCari: {
    //   handler: function (newVal, oldval) {
    //     if (newVal.length > 3 || newVal.length === 0) {
    //       this.getList()
    //     }
    //   },
    // },
    qCari: debounce(function() {
      this.istYpingSearch = false
    }, 500),
    istYpingSearch: function(value) {
      if (!value) {
        this.currentPage = 1
        this.getList()
        this.istYpingSearch = true
      }
    },
    perPage: {
      handler: function(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.currentPage = 1
          this.getList()
        }
      },
    },
  },
  mounted() {
    this.getList()
    this.getSummaryProyek()
    // this.formFields = this.model;
    this.years.push('ALL')
    for (var i = this.year; i >= 2022; i--) {
      this.years.push(i)
    }
  },
  methods: {
    ...crudMethods,
    getList() {
      this.listData({
        url: `${this.url}?page=${this.currentPage}&q=${this.qCari}&per_page=${this.perPage}&year=${this.year}`,
      }).then((response) => {
        this.items = []
        const data = response.data.data
        const meta = response.data.meta

        this.rows = meta.total
        this.perPage = meta.per_page
        this.currentPage = meta.current_page
        this.from = meta.from
        this.to = meta.to
        this.total = meta.total

        this.items = data
      })
    },
    getSummaryProyek() {
      this.listData({
        url: `web/dashboard/summary-proyek?year=${this.year}`,
      }).then((response) => {
        const { data } = response.data
        this.summary = data
      })
    },
    onValidated(isValid, errors) {
      this.isValid = isValid
    },
    showModalDokumen(item) {
      let tDokumens = JSON.parse(JSON.stringify(this.dokumens))
      if (item.rab) {
        tDokumens.find((x) => x.tipe === 'RAB').status = true
      }
      if (item.panjar) {
        tDokumens.find((x) => x.tipe === 'PANJAR').status = true
      }
      let dokumens = item.dokumen
      dokumens.forEach((vDokumen) => {
        tDokumens.forEach((sDokumen) => {
          if (vDokumen.tipe === sDokumen.tipe) {
            sDokumen.status = true
          }
        })
      })

      this.showDokumens = tDokumens
      this.$set(this.showDokumens, tDokumens)

      this.modalDokumen = true
    },
    showModalAllDokumen() {
      this.listData({
        url: `/web/laporan/dokumen?year=${this.year}`,
      }).then((response) => {
        let data = response.data.data

        let proyeks = []
        data.forEach((item) => {
          let dokumens = JSON.parse(JSON.stringify(this.dataDokumens))
          dokumens.forEach((dokumen) => {
            dokumen.jumlah = item[dokumen.tipe]
          })
          let obj = {
            kode_proyek: item.kode_proyek,
            nama_proyek: item.nama_proyek,
            dokumens: dokumens,
            filter: false,
          }
          proyeks.push(obj)
        })
        this.dokumenProyeks = proyeks
        this.modalAllDokumen = true
      })
    },
    getPercentage(item) {
      let tDokumens = JSON.parse(JSON.stringify(this.dokumens))
      if (item.rab) {
        tDokumens.find((x) => x.tipe === 'RAB').status = true
      }
      if (item.panjar) {
        tDokumens.find((x) => x.tipe === 'PANJAR').status = true
      }
      let dokumens = item.dokumen
      dokumens.forEach((vDokumen) => {
        tDokumens.forEach((sDokumen) => {
          if (vDokumen.tipe === sDokumen.tipe) {
            sDokumen.status = true
          }
        })
      })
      const trueData = tDokumens.filter((x) => x.status === true).length
      const totalData = tDokumens.length
      return Math.round((trueData / totalData) * 100)
    },
    changeStatus(item) {
      console.log(item)
      let text = 'Apakah anda yakin, untuk menutup proyek ini?'
      let status = 'CLOSE'

      if (item.status === 'CLOSE') {
        text = 'Apakah anda yakin, untuk membuka proyek ini?'
        status = 'AKTIF'
      }
      // text = 'Apakah anda yakin, untuk membuka proyek ini?'

      this.$bvModal
        .msgBoxConfirm(`${text}`, {
          title: 'Mohon Konfirmasi',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'YA',
          cancelTitle: 'TIDAK',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          let body = {
            status: status,
          }
          if (value) {
            this.updateData({
              url: `${this.url}/${item.id}/change-status`,
              body: body,
            }).then((response) => {
              this.getList()
              this.getSummaryProyek()
              this.toast('b-toaster-bottom-right', true, ' Berhasil Dihapus')
            })
          }
        })
    },
    changeYear() {
      this.getList()
      this.getSummaryProyek()
    },
    downloadProyek() {
      this.downloadData({
        url: `web/export/proyek?year=${this.year}`,
      }).then((response) => {
        // console.log(response)
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'list-proyek.xlsx')
        document.body.appendChild(link)
        link.click()
      })
    },
    downloadDokumen() {
      let queryFilterDokumen = ''
      let queryUpload = ''
      if (this.filterJumlah === 'SEMUA') {
        queryUpload = '&uploaded=1'
      } else {
        queryUpload = '&uploaded=0'
      }
      let filterDokumens = this.dataDokumens.filter((x) => !x.filter)
      filterDokumens.forEach((item) => {
        queryFilterDokumen = queryFilterDokumen + `&documents[]=${item.tipe}`
      })
      this.downloadData({
        url: `web/export/tracking-dokumen?year=${this.year}${queryUpload}${queryFilterDokumen}`,
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'tracking-dokumen.xlsx')
        document.body.appendChild(link)
        link.click()
      })
    },
    toggle(tipe) {
      const filter = this.dataDokumens.find((x) => x.tipe === tipe).filter
      this.dataDokumens.find((x) => x.tipe === tipe).filter = !filter
      this.changeFilterJumlah()
    },
    changeFilterJumlah() {
      this.dokumenProyeks.forEach((item) => {
        item.filter = false
        if (this.filterJumlah === 'BELUM UPLOAD') {
          let jumlah = 0
          let dataDokumens = this.dataDokumens.filter((y) => !y.filter)
          dataDokumens.forEach((dataDokumen) => {
            item.dokumens.forEach((dokumen) => {
              if (dokumen.tipe === dataDokumen.tipe && dokumen.jumlah === 0)
                jumlah++
            })
          })
          if (jumlah === 0) {
            item.filter = true
          }
        }
      })
    },
    toast(toaster, append = false, body) {
      this.counter++
      this.$bvToast.toast(`${this.title} ${body}`, {
        title: this.title,
        toaster: toaster,
        solid: true,
        appendToast: append,
        variant: 'success',
      })
    },
  },
}
</script>
<template>
  <div>
    <div class="row mt-4">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="header-title mt-0 mb-1">Data {{ title }}</h4>
            <p class="sub-header">
              {{ subtitle }}
            </p>
            <div class="d-flex flex-column gap-10">
              <ProjectSummary :summary="summary" />
              <div
                class="d-flex gap-20 justify-content-between margin-bottom-10"
              >
                <div class="d-flex items-end gap-10 flex-fill gap-10">
                  <div class="dropdown-float width-200-px">
                    <span>Periode Tahun</span>
                    <b-form-select
                      v-model="year"
                      :options="years"
                      @change="changeYear"
                    >
                    </b-form-select>
                  </div>

                  <div class="input-group-custom search-input flex-fill">
                    <!-- Ditambahkan style="cursor: text;" untuk memaksa kursor kembali normal -->
                    <input
                      v-model="qCari"
                      type="text"
                      class="form-control"
                      placeholder="Cari kode atau nama proyek..."
                      style="cursor: text;"
                    />
                    <!-- Ditambahkan style="cursor: pointer;" agar ikon kaca pembesar yang bisa diklik tetap memiliki efek tangan -->
                    <feather
                      type="search"
                      size="18"
                      class="search-icon"
                      style="cursor: pointer;"
                    ></feather>
                  </div>
                </div>
                <b-dropdown
                  right
                  variant="primary"
                  class="float-right"
                  no-caret
                >
                  <template v-slot:button-content>
                    <i class="fa fa-cogs"></i> Aksi Proyek
                  </template>

                  <b-dropdown-item v-if="checkAuthorized" :to="`${routes}/add`">
                    <i class="uil uil-plus-circle mr-2"></i> Buat data proyek
                  </b-dropdown-item>

                  <b-dropdown-item @click="showModalAllDokumen">
                    <i class="uil uil-file mr-2"></i> Tracking dokumen
                  </b-dropdown-item>

                  <b-dropdown-item @click="downloadProyek">
                    <i class="uil uil-download-alt mr-2"></i> Export data
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </div>
            <div class="table-responsive">
              <ProjectTable
                :items="items"
                :fields="fields"
                :user="user"
                :routes="routes"
                :dokumens="dokumens"
                :current-page="currentPage"
                @click-dokumen="showModalDokumen"
                @change-status="changeStatus"
              />
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6"
                ><p>Data {{ from }} ke {{ to }} dari {{ total }} data</p></div
              >
              <div class="col-sm-12 col-md-6">
                <div class="text-md-right">
                  <b-pagination
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                    first-text="First"
                    prev-text="Prev"
                    next-text="Next"
                    last-text="Last"
                    class="d-inline-flex"
                    @input="getList"
                  >
                  </b-pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      v-model="modalDokumen"
      title-class="text-center"
      centered
      hide-header
      hide-footer
      no-close-on-backdrop
    >
      <div>
        <div class="row">
          <div class="col-sm-12">
            <div class="table-responsive">
              <table class="table table-sm">
                <thead>
                  <tr>
                    <th>No</th>
                    <th>Nama Dokumen</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in showDokumens" :key="index">
                    <td>
                      {{ index + 1 }}
                    </td>
                    <td>
                      {{ item.name }}
                    </td>
                    <td>
                      <span class="text-primary">
                        <i v-if="item.status" class="fa fa-check"></i
                      ></span>
                      <span class="text-danger"
                        ><i v-if="!item.status" class="fa fa-times"></i>
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="text-center">
        <b-button
          block
          class="mr-2"
          type="button"
          variant="outline-primary"
          @click="modalDokumen = false"
          >Keluar</b-button
        >
      </div>
    </b-modal>
    <b-modal
      v-model="modalAllDokumen"
      title-class="text-center"
      centered
      hide-footer
      no-close-on-backdrop
      size="xl"
      title="Tracking Dokumen Proyek"
      modal-class="modal-print"
    >
      <div>
        <div class="row">
          <div class="col-sm-12 d-flex gap-5 mb-2">
            <div class="d-flex">
              <label class="mb-0 width-120-px">Daftar Dokumen</label>
              <label class="mb-0">: </label>
            </div>
            <div class="d-flex gap-15 align-items-center flex-wrap">
              <div
                v-for="(item, indexD) in dataDokumens"
                :key="indexD"
                class="d-flex align-items-center"
              >
                <b-form-checkbox
                  v-model="item.filter"
                  :value="false"
                  :unchecked-value="true"
                  size="sm"
                  @change="toggle(item.tipe)"
                >
                  {{ item.name }}
                </b-form-checkbox>
              </div>
            </div>
          </div>
          <div class="col-sm-12 d-flex gap-3 mb-3 align-items-center">
            <div class="d-flex">
              <label class="mb-0 width-120-px">Tampilkan</label>
              <label class="mb-0">: </label>
            </div>
            <b-form-select
              v-model="filterJumlah"
              class="width-150-px"
              :options="filterJumlahs"
              size="sm"
              @change="changeFilterJumlah"
            >
            </b-form-select>
          </div>
          <div class="col-sm-12 d-flex gap-3 mb-3 align-items-center">
            <div class="d-flex">
              <label class="mb-0 width-120-px">Download</label>
              <label class="mb-0">: </label>
            </div>
            <button class="btn btn-sm btn-primary" @click="downloadDokumen">
              <i class="uil uil-download-alt ml-1"></i>
              Download
            </button>
          </div>
          <div class="col-sm-12">
            <div class="table-responsive">
              <table class="table table-sm">
                <thead>
                  <tr>
                    <th class="text-left">NO</th>
                    <th class="text-left">KODE</th>
                    <th class="text-left">NAMA</th>
                    <fragment
                      v-for="(item, index) in dataDokumens"
                      :key="index"
                    >
                      <th v-if="!item.filter">
                        {{ item.name }}
                      </th>
                    </fragment>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, index) in dokumenProyeks.filter(
                      (x) => x.filter === false
                    )"
                    :key="index"
                  >
                    <td>{{ index + 1 }}</td>
                    <td>{{ item.kode_proyek }}</td>
                    <td>{{ item.nama_proyek }}</td>
                    <fragment
                      v-for="(dokumen, index2) in dataDokumens"
                      :key="index2"
                    >
                      <td v-if="!dokumen.filter" class="text-center">
                        <span
                          v-if="
                            item.dokumens.find((x) => x.tipe === dokumen.tipe)
                              .jumlah > 0
                          "
                          class="text-primary"
                        >
                          <feather
                            size="17"
                            type="check"
                            class="close-icon"
                          ></feather>
                        </span>
                        <span v-else class="text-danger">
                          <feather
                            size="17"
                            type="minus"
                            class="close-icon"
                          ></feather>
                        </span>
                      </td>
                    </fragment>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<style lang="scss">
.table-proyek {
  thead {
    th {
      text-align: left !important;
    }
  }
}
.action-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
  .action-left-side {
    width: 50%;
    .custom-select {
      width: 75px;
    }
  }
  .action-right-side {
    width: 50%;
    display: flex;
    align-items: center;
    gap: 10px;
    justify-content: flex-end;
    .year-action {
      display: flex;
      align-items: center;
      width: 125px;
      gap: 5px;
      label {
        margin-bottom: 0px;
      }
    }
    .input-group {
      width: 350px;
    }
  }
}

.dropdown-float {
  position: relative;
  span {
    position: absolute;
    top: -9px;
    left: 10px;
    font-size: 11px;
    font-weight: 600;
    z-index: 10;
    background-color: #fff;
    padding: 0 4px;
    color: #555;
  }
  select {
    height: 38px;
    color: #000;
    font-weight: 600;
    border-radius: 4px;
    border: 1px solid #ccc;
  }
}
</style>
